import { apply, call, put } from 'redux-saga/effects';
import get from 'lodash/get';
import Http from '../../../../libs/Http';
import history from '../../../../history';

export function* postToken(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  try{
    const data = yield call(Http.post, '/ebayAccounts/token', {
      body: {
        code: payload.code,
      }
    });
    yield apply(history, history.replace, ['/ebay']);

  } catch (e) {
    const message = get(e, 'data.errors[0].message', 'There was an error getting the token');

    yield put({
      // $global: true,
      type: 'SET_ACCEPTED',
      payload: {
        message,
      },
      error: e,
    });
  }

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function*({ takeFirst }) {
  yield [
    takeFirst('TOKEN_RECEIVED', postToken),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/OAuth/Accepted/Accepted.sagas.js